import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import MainPage from './browser/MainPage';
import ResultPage from './browser/ResultPage';
import QuestionnairePage from './browser/Questionnaire';
import ScrollToTop from './browser/components/ScrollToTop.react';

const App = () => (
  <Router>
    <ScrollToTop>
      <Switch>
        <Route exact path="/:field_id/project-health-check" component={MainPage} />
        <Route exact path="/:field_id/project-health-check/result" component={ResultPage} />
        <Route path="/:field_id/project-health-check/:id" component={QuestionnairePage} />
        <Route exact path="/:field_id/audit" component={MainPage} />
        <Route exact path="/:field_id/audit/result" component={ResultPage} />
        <Route path="/:field_id/audit/:id" component={QuestionnairePage} />
      </Switch>
    </ScrollToTop>
  </Router>
);

export default App;
